<template>
  <div class="table--sugerido">
    <h6 class="font-weight-bold">
      <div class="row">
        <div class="col">
          Total: <br />
          {{ total | currency }}
        </div>
        <div class="col">
          Grupos: <br /><span v-html="parseGrupos(totalGrupo)"></span>
        </div>
        <div class="col">Presupuesto periodo {{period}}: <br> {{budget | currency}} </div>
        <div :class="`col ${purchaseClass()}`">Presupuesto usado: <br> {{currentPurchase | currency}} ({{porcentaje}}%)</div>
      </div>
    </h6>
    <h6 class="pull-right font-weight-bold">Página actual: {{ current }}</h6>

    <table
      class="table table-striped table-bordered table-info table-responsive"
    >
      <thead>
        <tr>
          <th>Cód. Prov</th>
          <th>Proveedor</th>
          <th>Codigo</th>
          <th>Descripción</th>
          <th>Categoria</th>
          <th>Grupo</th>
          <th>Sucursal</th>
          <th>Stock</th>
          <th>Stock MIN.</th>
          <th>Stock MAX.</th>
          <th>A Comprar</th>
          <th>Precio</th>
          <th>Costo Prov.</th>
          <th>Costo</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          :class="{ 'table-active': productoEnCarroFinder(item) }"
          v-for="(item, index) in productos"
          :key="index"
        >
          <td width="7%">{{ item.codigo_proveedor | upper }}</td>
          <td>{{ item.proveedor | upper }}</td>
          <td>{{ item.codigo }}</td>
          <td>{{ item.descripcion | upper }}</td>
          <td>{{ printCategoria(item) | upper }}</td>
          <td>{{ item.grupo | upper }}</td>
          <td>{{ printSucursal(item) | upper }}</td>
          <td>{{ item.stock }}</td>
          <td>{{ item.stock_minimo }}</td>
          <td>{{ item.stock_maximo }}</td>
          <td width="6">
            <input
              style="width: 100%"
              v-model="item.cantidad_a_comprar"
              :placeholder="item.cantidad_a_comprar"
              maxlength="2"
              type="number"
              min="0"
              max="99"
            />
          </td>
          <td>{{ item.precio | currency }}</td>
          <td>{{ item.costo_proveedor | currency }}</td>
          <td>
            <input
              style="width: 100%"
              v-model="item.costo_pactado"
              :placeholder="item.costo_pactado"
              maxlength="2"
              type="number"
              min="0"
              max="99"
            />
          </td>

          <td>
            <i
              v-if="sucursal === ''"
              class="fa fa-eye pointer mr-1"
              title="Detalle"
              @click="openDetail(item)"
            ></i>
            <i
              class="fa fa-plus-circle pointer"
              title="Añadir al carro"
              @click="sendItem(item)"
            ></i>
            <i
              class="fa fa-archive"
              title="Cambiar proveedor"
              @click="proveedorModal(item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <detalle-producto-sugerido :producto="producto" ref="detalleProducto" />
    <cambio-proveedor-modal
      :producto="producto"
      ref="cambioProveedor"
      @updated="proveedorUpdated"
    />
    <div class="paginacion">
      <custom-pagination />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DetalleProductoSugerido from "../DetalleProductoSugerido";
import CustomPagination from "../CustomPagination"; //manejo de paginas
import CambioProveedorModal from "components/compra/component/cambioProveedorModal";
import {budgetUrlProvider} from "../../../../util/budgetUrlProvider";
import moment from "moment";

export default {
  name: "tablaSugeridoCompra",
  components: {
    CambioProveedorModal,
    CustomPagination,
    DetalleProductoSugerido
  },
  props: ['currentProvider'],
  beforeCreate() {
    this.$store.dispatch("loadCategoria");
    this.$store.dispatch("sugeridoCompra/getTotales");
  },
  created() {
    this.loadBudget()
  },
  computed: {
    ...mapGetters({
      carro: "sugeridoCompra/productosCarro",
      current: "sugeridoCompra/currentPage",
      total: "sugeridoCompra/total",
      totalGrupo: "sugeridoCompra/totalGrupo"
    }),
    porcentaje() {
      return Math.round((this.currentPurchase * 100) / this.budget) || 0
    },
    productos() {
      return this.$store.getters["sugeridoCompra/productosSugerido"]
        .map(item => ({
          ...item,
          cantidad_a_comprar: item.stock_maximo - item.stock,
          costo_pactado: item.costo_proveedor
        }))
        .filter(p => p.cantidad_a_comprar > 0);
    }
  },
  methods: {
    ...mapActions({
      sendItem: "sugeridoCompra/sendItemsToCar"
    }),
    purchaseClass() {
      const ratio = this.currentPurchase / this.budget
      if (ratio <= 0.5) return "budget-ok";
      if (ratio > 0.5 && ratio <= 0.75) return "budget-warning";
      return "budget-danger"
    },
    async loadBudget() {
      this.period = this.getCurrentPeriod()
      const {data} = await this.$axios.get(budgetUrlProvider(this.period, this.currentProvider))
      this.budget = data.total_budget
      this.currentPurchase = data.total_current_purchase
    },
    getCurrentPeriod() {
      return moment().format("yyyy/MM")
    },
    parseGrupos(totalGrupo) {
      return Object.keys(totalGrupo)
        .map(
          k =>
            `<span>${k.toUpperCase()}: $${totalGrupo[
              k
            ].toLocaleString()}</span>`
        )
        .join(" ");
    },
    proveedorUpdated() {
      this.$store.dispatch("sugeridoCompra/getProductosSugerido");
    },
    productoEnCarroFinder(item) {
      const findCarro = this.carro.find(
        c => c.producto_id === item.producto_id
      );
      return findCarro !== undefined;
    },
    printSucursal(item) {
      const stateSucursal = this.$store.state.sugeridoCompra.filtros.sucursal;
      const sucursal = this.$store.getters.sucursal(item.sucursal_id).nombre;
      if (stateSucursal === "" && sucursal === "Web") return "todas";
      return sucursal;
    },
    printCategoria(item) {
      return this.$store.getters.categorias.find(
        s => s.id === item.categoria_id
      ).nombre;
    },
    openDetail(item) {
      this.producto = { item };
      this.$refs.detalleProducto.openModal();
    },
    proveedorModal(item) {
      this.producto = { ...item };
      this.$refs.cambioProveedor.openModal();
    }
  },
  data() {
    return {
      producto: {},
      sucursal: this.$store.state.sugeridoCompra.filtros.sucursal,
      value: 50,
      budget: 0,
      currentPurchase: 0,
      period: ""
    };
  }
};

// Información
//Presupuesto Mensual Consolidado
//R: presupuesto mes año pasado+el porcentaje q indiquen
//Presupuesto mensual proveedor
//R: presupuesto mes año pasado del proveedor+el porcentaje q indiquen
//Compras mes en curso Consolidado
//R: total de compras hasta el momento/Presupuesto Mensual Consolidado
//Compras mes en curso Proveedor
//R: total de compras hasta el momento/Presupuesto Mensual Consolidado del proveedor
//Porcentaje de cumplimiento consolidado
//R: total de compras hasta el momento/Presupuesto Mensual Consolidado a porcentaje
//Porcentaje de cumplimiento proveedor
//R: total de compras hasta el momento/Presupuesto Mensual Consolidado del proveedor a porcentaje
</script>

<style scoped>
.paginacion {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
table {
  font-size: 15px;
}
.budget-ok {
  color: green;
}

.budget-warning {
  color: #eec40b;
}

.budget-danger {
  color: #990909;
}

</style>
